import { CommonModule } from '@angular/common';
import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { AbstractBaseFieldComponent } from '@shared/components/form-elements/abstract-field-base';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';
import { DatePicker } from 'primeng/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'cx-calendar-field',
  imports: [CommonModule, FormsModule, FormErrorsModule, DatePicker],
  templateUrl: './calendar-field.component.html',
  styleUrls: ['./calendar-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CalendarFieldComponent),
      multi: true,
    },
  ],
  host: {
    '[attr.id]': 'null',
  },
})
export class CalendarFieldComponent extends AbstractBaseFieldComponent implements ControlValueAccessor, OnInit {
  @Input() control?: AbstractControl | null;
  @Input() label = '';
  @Input() hintText = '';
  @Input() icon = '';
  @Input() id = this.generateId();
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() valid?: boolean;
  @Input() invalid?: boolean;
  @Input() rangeDates: any[] = [];
  @Input() bindLabel = 'label';
  @Input() bindValue = 'value';
  @Input() loading = false;
  @Input() typeahead = new Subject<string>();
  @Input() minDate = new Date();

  override value?: string | undefined;

  override writeValue(value: any): void {
    this.value = value || undefined;
  }

  private readonly config = inject(PrimeNG);
  private readonly translateService = inject(TranslateService);

  onChangeCalendar(event: Event): void {
    this.onChange(event);
  }

  ngOnInit() {
    this.translateService.use('pt-BR');
    this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
  }
}
